import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'me-separator',
  styleUrl: 'me-separator.scss',
  shadow: false,
})
export class MeSeparator {

  @Prop() direction: 'horizontal' | 'vertical' = 'horizontal'

  render() {
    return (
      <Host class={`me-separator me-separator--${this.direction}`} />
    );
  }

}
